import React from 'react';
import { Icon ,IconButton,Slider,ButtonToolbar,Dropdown,ButtonGroup,Tooltip, Whisper,Button} from 'rsuite';
const RightsliderbarStyle={
    position:"fixed",
    zIndex:99,
    bottom:"30px",
    right: (-document.body.clientWidth+330)+"px"
}
const modelSettingStyle={
    position:"fixed",
    width:"150px",
    zIndex:99,
    top:"60px",
    right:(-document.body.clientWidth+330)+"px"
}
const pmtooltip = (
    <Tooltip>
      缩放
    </Tooltip>
  );
const xztooltip = (
<Tooltip>
    旋转
</Tooltip>
);
const locationtooltip = (
    <Tooltip>
        定位
    </Tooltip>
);
export default class Rightsliderbar extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            lock:false
        }
    }

    isLock=()=>{
        if(this.state.lock){
            return(<IconButton icon={<Icon icon="lock"/>} onClick={this.props.focus} />)
        }
        else{
            return(<IconButton icon={<Icon icon="dot-circle-o"/>} onClick={this.props.focus} />)
        }
    }

    render() {
        return(
            <div>
                <div style={modelSettingStyle}>
                <Dropdown title="模型设置" toggleComponentClass={Button} appearance="default">
                <Dropdown.Item>
                    模型透明度
                    <br/>
                    <br/>
                    <Slider style={{ width: 100 }} onChange={this.props.modelAlpha}/>
                </Dropdown.Item>
                </Dropdown>
                </div>

            <div style={RightsliderbarStyle}>
                <ButtonToolbar>
            <Whisper placement="left" trigger="hover" speaker={locationtooltip}>
            <ButtonGroup vertical>
                {this.isLock()}
            </ButtonGroup >
            </Whisper>
            </ButtonToolbar>
            <br/>
            <Whisper placement="left" trigger="hover" speaker={xztooltip}>
            <ButtonGroup vertical>
            <IconButton icon={<Icon icon="angle-left"/>} onClick={this.props.turnButUp} /> 
            <Dropdown placement="leftStart"  renderTitle={() => {
                                return <IconButton appearance="primary" icon={<Icon icon="sliders"/>} />;
                            }}>
                        <Dropdown.Item>
                        <Slider style={{ width: 200 }} max={Math.PI*2+0.1} step={0.1} onChange={this.props.turnSliderBarChange} />
                        </Dropdown.Item>
                    </Dropdown>
            <IconButton icon={<Icon icon="angle-right"/>}  onClick={this.props.turnButDown} />
            </ButtonGroup>
            </Whisper>
            <br/>
            <br/>
            <ButtonToolbar>
            <Whisper placement="left" trigger="hover" speaker={pmtooltip}>
                <ButtonGroup vertical>
                    <IconButton icon={<Icon icon="plus"/>} onClick={this.props.upDownButUp} />                    
                    <Dropdown placement="leftStart" renderTitle={() => {
                                return <IconButton appearance="primary" icon={<Icon icon="sliders"/>} />;
                            }}>
                        <Dropdown.Item>
                        <Slider style={{ width: 200 }} max={1} step={0.1} onChange={this.props.upDownSliderBarChange} />
                        </Dropdown.Item>
                    </Dropdown>
                    <IconButton icon={<Icon icon="minus"/>} onClick={this.props.upDownButDown} /> 
                </ButtonGroup>
            </Whisper>
            </ButtonToolbar>
            
            </div>
            </div>
        )
    }
    
}